module.exports = __webpack_public_path__ + "img/1486712238.14052847.jpg";